import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: localStorage.getItem('UTOPA_LANGUAGE') || 'cn' // cn 中, en 英, zh 繁
  },
  mutations: {
    CHANGE_LANGUAGE (state, language) {
      state.language = language
      localStorage.setItem('UTOPA_LANGUAGE', language)
    }
  },
  actions: {
    CHANGE_LANGUAGE ({ commit }, language) {
      commit('CHANGE_LANGUAGE', language)
    }
  }
})
